import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-20 bg-white" data-id="element-156">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="border-l-4 border-[#C97B63] pl-6 md:pl-10" data-id="element-159">
            <p className="text-xl md:text-2xl text-[#2A2A2A] leading-relaxed mb-6 font-serif italic" data-id="element-160">
              Son las 7:15 AM de un lunes. Te miras al espejo y pruebas ese
              pantalón que hace tres meses te quedaba perfecto. Hoy, el cierre
              no sube.
            </p>
            <p className="text-lg text-[#2A2A2A] leading-relaxed mb-6" data-id="element-161">
              Sientes ese nudo en la garganta y la misma pregunta de siempre:{' '}
              <br data-id="element-162" />
              <strong className="text-[#1A5C4C] font-serif text-xl" data-id="element-163">
                "Si casi no como... ¿por qué sigo subiendo de peso?"
              </strong>
            </p>
            <p className="text-lg text-[#2A2A2A] leading-relaxed" data-id="element-164">
              No es tu falta de voluntad. No es que necesites más cardio. Es que
              después de los 45, tu cuerpo cambió las reglas del juego. Tu
              metabolismo no está "roto", está bloqueado por tus propias
              hormonas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}